import { render } from "./ControlPanel.vue?vue&type=template&id=06970e47&scoped=true"
import script from "./ControlPanel.vue?vue&type=script&lang=js"
export * from "./ControlPanel.vue?vue&type=script&lang=js"

import "./ControlPanel.vue?vue&type=style&index=0&id=06970e47&scoped=true&lang=css"

import exportComponent from "c:\\Qedtek Project\\Takayama-New\\takayama_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06970e47"]])

export default __exports__